import { useTranslation } from "react-i18next";
import pfp1 from "../../assets/img/pfp/pfp1.webp";
import pfp2 from "../../assets/img/pfp/pfp2.webp";

export default function Team() {
  const { t } = useTranslation();

  return (
    <section className="Team fade">
      <h2>{t("team.title")}</h2>
      <ul className="team-cards">
        <li className="team-card">
          <img src={pfp2} alt="Mary" />
          <h3>Mary</h3>
          <p>{t("team.mary.text1")}</p>
          <p>{t("team.mary.text2")}</p>
        </li>
        <li className="team-card">
          <img src={pfp1} alt="Anna" />
          <h3>Anna</h3>
          <p>{t("team.anna.text1")}</p>
          <p>{t("team.anna.text2")}</p>
        </li>
      </ul>
    </section>
  );
}
